import { render, staticRenderFns } from "./requirements-section.vue?vue&type=template&id=996df16c&scoped=true&"
import script from "./requirements-section.vue?vue&type=script&lang=js&"
export * from "./requirements-section.vue?vue&type=script&lang=js&"
import style0 from "./requirements-section.vue?vue&type=style&index=0&id=996df16c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "996df16c",
  null
  
)

export default component.exports